import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Sparkles, X } from "lucide-react";
import { API } from "../auth/AuthContext";
import {
  GIVEAWAY_BANNER_LABEL,
  GIVEAWAY_CAMPAIGN_HARD_OFF,
  GIVEAWAY_EVENT_SLUG,
  GIVEAWAY_PATH,
} from "../lib/giveawayCampaign";

const DISMISS_KEY = "zc_giveaway_banner_dismissed_v1";

export default function GiveawayCampaignBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === "1";
    } catch {
      return false;
    }
  });
  const [enabled, setEnabled] = useState(null);

  useEffect(() => {
    if (GIVEAWAY_CAMPAIGN_HARD_OFF) {
      setEnabled(false);
      return;
    }
    let alive = true;
    (async () => {
      try {
        const r = await axios.get(`${API}/giveaway/${GIVEAWAY_EVENT_SLUG}/info`);
        if (alive) setEnabled(r.data?.enabled !== false);
      } catch {
        if (alive) setEnabled(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  if (GIVEAWAY_CAMPAIGN_HARD_OFF || enabled !== true || dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(DISMISS_KEY, "1");
    } catch {
      /* ignore */
    }
  };

  return (
    <div
      className="border-b border-[var(--zc-border)] zc-giveaway-banner-flash"
      data-testid="giveaway-campaign-banner"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-2.5 flex items-center gap-3">
        <span
          className="w-8 h-8 rounded-full grid place-items-center shrink-0"
          style={{ background: "var(--zc-gradient-soft)", color: "var(--zc-accent)" }}
        >
          <Sparkles size={14} />
        </span>
        <Link
          to={GIVEAWAY_PATH}
          className="flex-1 min-w-0 text-sm sm:text-base font-semibold zc-giveaway-banner-text truncate"
          data-testid="giveaway-campaign-banner-link"
        >
          {GIVEAWAY_BANNER_LABEL}
        </Link>
        <button
          type="button"
          onClick={dismiss}
          className="w-8 h-8 rounded-full grid place-items-center hover:bg-[var(--zc-bg-3)] transition shrink-0"
          aria-label="Dismiss giveaway banner"
          data-testid="giveaway-campaign-banner-dismiss"
        >
          <X size={14} className="text-[var(--zc-text-2)]" />
        </button>
      </div>
    </div>
  );
}
